module.exports = __webpack_public_path__ + "img/img-30@2x.a3afd3da.png";